import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  billingHistoryRequest: ['page', 'page_size', 'id'],
  billingHistorySuccess: ['list'],

  billingHistorySetFocusRow: ['focusRow'],
  billingHistoryResetFocusRow: null,

  billingHistoryReset: null,

  billingHistoryFetchingReset: null,
  logout: null,
})

export const BillingHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,
  page: 1,
  page_size: 3,
  focusRow: null,
})

/* ------------- Selectors ------------- */
export const BillingHistorySelectors = {
  getState: state => state.billingHistory,
}

export const billingHistoryRequest = (state, {page, page_size, id}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}
export const billingHistorySuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}
export const billingHistoryReset = () => {
  return INITIAL_STATE
}

export const billingHistorySetFocusRow = (state, {focusRow}) => {
  return state.merge({focusRow})
}
export const billingHistoryResetFocusRow = state => {
  return state.merge({focusRow: null})
}

export const billingHistoryFetchingReset = state => {
  return state.merge({fetching: false})
}

export const logout = state => {
  return INITIAL_STATE
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.BILLING_HISTORY_REQUEST]: billingHistoryRequest,
  [Types.BILLING_HISTORY_SUCCESS]: billingHistorySuccess,
  [Types.BILLING_HISTORY_RESET]: billingHistoryReset,

  [Types.BILLING_HISTORY_SET_FOCUS_ROW]: billingHistorySetFocusRow,
  [Types.BILLING_HISTORY_RESET_FOCUS_ROW]: billingHistoryResetFocusRow,

  [Types.BILLING_HISTORY_FETCHING_RESET]: billingHistoryFetchingReset,

  [Types.LOGOUT]: logout,
})
